import {getMethod} from '~/api'

async function get(request) {
    return await getMethod('/api/contracts', request)
}

export {get}
